import AbstractTimezone from './AbstractTimezone';
import TimezoneLayer from './component/TimezoneLayer';

class TimezoneLayerOnly extends AbstractTimezone {
  timezoneLayer!: TimezoneLayer;

  render() {
    this.timezoneLayer = new TimezoneLayer(this.config, this.emitter);
    this.content.element && this.timezoneLayer?.contentElement?.append(this.content.element);
    
    this.$parent?.append(this.timezoneLayer?.element);
  }

  open() {
    this.timezoneLayer?.open();
  }

  close() {
    this.timezoneLayer?.close();
  }

  addEvent() {
    this.emitter.addEvent('TOGGLE_OPEN_LAYER', (isOpen: boolean) => {
      isOpen ? this.content.update() : this.content.destroy();
    });
  }
}

export default TimezoneLayerOnly;